<template>
    <div>
        <div v-if="!loading" class="home-pag">
          <section class="event team-sec team-grid speaker set-relative py-5" id="speaker">
            <div class="container" style="padding:10px;margin:auto;border: 1px solid black;page-break-after: always;">
              <div class="row">
                <div class="col-md-12">
                  <div class="row">
                    <div class="col-md-2 text-center" style="widthx:35%;">
                      <img alt="" style="height:95px;margin-bottomx:5px" class="img-fluid" src="../../theme-assets/images/logo/cu_logo_black.png">
                    </div>
                    <div class="col-md-8 text-center" style="widthx:30%;">
                      <div class="col-md-12" style="margin-topx:-30px">
                          <h4 style="text-transform: unset;color:black;font-family: kalpurush;font-weight:bold;font-size:30px" align="center">চট্টগ্রাম বিশ্ববিদ্যালয়</h4>
                          <p style="text-align:center;font-size: large;font-family: kalpurush;color:black;padding:10px">১ম বর্ষ স্নাতক (সম্মান) ভর্তি পরীক্ষা, শিক্ষাবর্ষ: ২০২৬-২০২৭</p>
                      </div>             
                    </div>
                    <!--div class="col-md-2 text-center" style="widthx:35%;">
                      <img alt="" style="height:75px;margin-bottomx:5px" class="img-fluid" src="../../theme-assets/images/logo/mujib.png">
                    </div-->
                    
                    <div class="col-md-2 text-center" style="widthx:35%;">
                        <!--p align="center" style="color: black;font-size: 18px;margin-bottom: 2px;font-family:'Times New Roman', Times, serif;">
                          {{$route.params.unit}} Unit 
                        </p-->
                        <div class="qrcode" align="center" style="floatx:right;" ref="qrCodeUrl" id="qrCodeUrl"></div>
                    </div>
                  </div>
                </div>
                
                <div class="col-md-12" style="margin-bottom: 10px;">
                  <p style="text-align:center;font-size: 22px;font-weight:bold;font-family: kalpurush;color:black;padding:10px;">Subject-Choice List</p> 
                  
                  <p style="text-align:center;margin-bottom:10px" class="text-black">
                    <span class="px-3 py-1" style="border: 1px solid black;border-radius: 10px;">
                      Unit: <b>{{this.unit}}</b>&nbsp;Quota: <b>{{this.quota}}</b>
                    </span>
                  </p>
                </div>

                <div class="col-md-6" style="margin-bottom:15px">
                    <p style="font-size: 19px;color:black;font-family:'Times New Roman', Times, serif">Admission Roll: 
                      <span style="border: 2px solid black;border-right:1px;padding: 2px 7px 2px 7px;">{{exam_roll.charAt(0)}}</span>
                      <span style="border: 2px solid black;border-right:1px;padding: 2px 7px 2px 7px;">{{exam_roll.charAt(1)}}</span>
                      <span style="border: 2px solid black;border-right:1px;padding: 2px 7px 2px 7px;">{{exam_roll.charAt(2)}}</span>
                      <span style="border: 2px solid black;border-right:1px;padding: 2px 7px 2px 7px;">{{exam_roll.charAt(3)}}</span>
                      <span style="border: 2px solid black;border-right:1px;padding: 2px 7px 2px 7px;">{{exam_roll.charAt(4)}}</span>
                      <span style="border: 2px solid black;padding: 2px 7px 2px 7px;">{{exam_roll.charAt(5)}}</span>
                    </p>
                </div>
                <div class="col-md-6" style="margin-bottom:30px">
                    <p style="font-size: 19px;color:black;text-align:right;font-family:'Times New Roman', Times, serif">Application ID:
                      <span style="border: 2px solid black;border-right:1px;padding: 2px 7px 2px 7px;">{{application_id.charAt(0)}}</span>
                      <span style="border: 2px solid black;border-right:1px;padding: 2px 7px 2px 7px;">{{application_id.charAt(1)}}</span>
                      <span style="border: 2px solid black;border-right:1px;padding: 2px 7px 2px 7px;">{{application_id.charAt(2)}}</span>
                      <span style="border: 2px solid black;border-right:1px;padding: 2px 7px 2px 7px;">{{application_id.charAt(3)}}</span>
                      <span style="border: 2px solid black;border-right:1px;padding: 2px 7px 2px 7px;">{{application_id.charAt(4)}}</span>
                      <span style="border: 2px solid black;padding: 2px 7px 2px 7px;">{{application_id.charAt(5)}}</span>
                    </p>
                </div>             
                <div class="col-md-12">
                  <div class="card">
                    <div class="card-header bg-dark text-white" style="font-weight:bold">Applicant's Info</div>
                    <div class="card-body">
                      <table class="table" style="font-weight: bold;margin:auto">
                        <tr>
                          <td class="count-desc">Name</td>
                          <td class="count-desc">:</td>
                          <td class="count-desc">{{applicant.name}}</td>
                        </tr>
                        <tr>
                          <td class="count-desc">Father's Name</td>
                          <td class="count-desc">:</td>
                          <td class="count-desc">{{applicant.fname}}</td>
                        </tr>
                        <tr>
                          <td class="count-desc">Mother's Name</td>
                          <td class="count-desc">:</td>
                          <td class="count-desc">{{applicant.mname}}</td>
                        </tr>
                        <tr>
                          <td class="count-desc">Total Score</td>
                          <td class="count-desc">:</td>
                          <td class="count-desc">{{examResult.total}}</td>
                        </tr>
                        <tr>
                          <td class="count-desc">Merit Position</td>
                          <td class="count-desc">:</td>
                          <td class="count-desc">{{examResult.merit}}</td>
                        </tr>
                      </table>
                    </div>
                  </div>

                  <div class="card mt-3">
                    <div class="card-header bg-dark text-white" style="font-weight:bold">Subject-Choice List</div>
                    <div class="card-body">
                      <table class="table" style="font-weight: boldx;margin:auto">
                        <tr class="table-info">
                          <th class="count-desc text-center">Department Code</th>
                          <th class="count-desc text-left">Name of the Department/Institute</th>
                          <th class="count-desc text-center">Choice Serial</th>
                        </tr>
                        <tr v-for="subject in selectedSubjects" :key="subject.serial">
                          <td class="count-desc text-center">{{subject.code}}</td>
                          <td class="count-desc text-left">{{subject.title}}</td>
                          <td class="count-desc text-center">{{subject.serial}}</td>
                        </tr>
                      </table>
                    </div>
                  </div>

                </div>           
              </div>
              <div class="row pt-0 mt-2">
                <div class="col-md-6 mb-0 mt-auto" style="vertical-align: bottom;">
                  <span style="font-style:italic;">Powered by <b>ICT Cell, University of Chittagong</b></span>
                </div>
                <div class="col-md-6" style="margin-top:10px;text-align:right;">
                  <!--img alt="" style="width:120px;margin-bottom:5px;margin-right:5px" class="img-fluid" :src="co_ordinator_signature">
                  <p style="text-align:right;line-height:1.2;color:black;padding-top:10px;font-family: kalpurush;font-size:15px">
                    {{unit_co_ordinator}}
                    <br> কো-অর্ডিনেটর,  
                    <span style="font-family:'Times New Roman', Times, serif">{{$route.params.unit}}</span> ইউনিট ভর্তি কমিটি 
                  </p-->
                </div>
              </div>
            </div>
          </section>         
        </div>
        <div v-else>
            <loader class="loader"></loader> <br />
        </div>
        
    </div>
</template>

<script>
import Loader from '../Helper/Loader'
import Banner from '../Partial/Banner'
import { GET_SUBJECT_CARD, GET_DOCS } from '../../const/api'
import { GET } from '../../utils/Request'
import QRCode from 'qrcodejs2'
export default {
  name: 'SubjectChoice',
  components: { Loader, Banner },
  data() {
    return {
        loading: false,
        Schedule:'',
        firstTimeLoad: true,
        qrText:'',

        unit:'',
        quota:'',
        exam_roll:'',
        application_id:'',
        message:'',
        subjects: [],
        selectedSubjects: {},
        save_choice: true,

        applicant:{},
        examResult:{},        
    }
  },
  computed: {
    isOnHomepage() {
      let routeName = this.$route.name
      return routeName == 'home' ? true : false
    }
  },
  created() {
    this.getDocs();
  },
  mounted() { 
  },
  methods: {
    
    async getDocs() {
      
      var data = await GET(GET_SUBJECT_CARD + this.$route.params.unit + '/' + this.$route.params.quota);
      
      /*console.log('Subjectchoice', data.data);*/

      if(data.data.status=='success'){  
        this.applicant = data.data.applicant;
        this.examResult = data.data.result;
        
        this.unit = data.data.unit;
        this.quota = data.data.quota;
        
        this.exam_roll = '' + data.data.exam_roll;
        this.application_id = '' + data.data.application_id;

        /*console.log(this.exam_roll);*/
        
        this.save_choice = data.data.save_choice;
        this.selectedSubjects = data.data.selected_subjects;

        this.message = '';

        /*this.qrText = 'Unit:'+this.$route.params.unit
          + ',Name:'+ this.studentInfo.name 
          + ', Father Name:'+ this.studentInfo.father_name 
          + ', Mother Name:'+ this.studentInfo.mother_name 
          + ',Roll:'+ data.data.exam_roll
          + ',AppID:'+ this.studentInfo.applicant_no
          + ',Medium:' + this.studentInfo.medium
          + ',Exam Date&Time:' + this.studentInfo.exam_date+' '+this.studentInfo.exam_time;*/

        /*this.qrText = 'http://dev.front.cu.ac.bd/check-subject-choice/' + data.data.hash_key;*/
        this.qrText = `${process.env.VUE_APP_FRONTEND_URL}check-subject-choice/${data.data.hash_key}`;
      }
      else{
        this.unit = '';
        this.quota = '';
        
        this.exam_roll = '      ';
        this.application_id = '      ';

        this.$iziToast.error({
            message: data.data.message
        });
        this.goForUrl('/');
      }
      this.timeoutForLoading();
      // console.log('Subjectchoice', this.exam_roll, this.examResult, this.selectedSubjects);
    },
    
    goForUrl(url) {
      this.$router.replace(url)
    },
    
    topFunction() {
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
    },
    timeoutForLoading() {
      if (this.firstTimeLoad) {
        this.$nextTick(() => {
          setTimeout(
            function() {
              this.loading = false;
              this.getQR();
              //window.print();
            }.bind(this),
            2000
          )
        })
      }
      this.firstTimeLoad = false
    },
    getQR(){
       let canvasDiv = document.createElement("div"); //New dom element, if there is only one page, you can use the page element directly
        canvasDiv.id = 'canvas'
        document.getElementById('qrCodeUrl').append(canvasDiv);
        /*qrcode generates QR code*/
        let qrcode = new QRCode('canvas', { 
          text: this.qrText,
          width: 100,
          height: 100,
          colorDark: '#000000',
          colorLight: '#ffffff',
          correctLevel: QRCode.CorrectLevel.H
        });
        /* Get the canvas element */
        let canvas = document.getElementById('canvas').querySelector('canvas') 
        var dataURL = canvas.toDataURL(); 
        canvas = null; 
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.bg {
  /* The image used */
  background-image: url("../../theme-assets/images/logo/cu_bg_logo.png");

  /* Full height */
  height: 100%;

  /* Center and scale the image nicely */
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}
.loader {
  margin-top: 20%;
}
.pdf-app{
  width:100%;
  height:182.5vh;
}
.d-flex{
  padding:10px;
  margin:10px;
  -webkit-box-shadow: 1px 0 15px 2px #c1b3b3;
    box-shadow: 1px 0 15px 2px #c1b3b3;
}
.home-page {
  background: url(../../assets/bg.svg);
  background-size: cover;
  /*font-family: 'Poppins', sans-serif;*/
}

.home-page section {
  padding: 5px 0px;
}

/* Header */


.img-fluid{
  max-width:100%;
}


/* advantages */
.advantages {
  -webkit-box-shadow: 0px 3px 10px 0px #dadada;
  -moz-box-shadow: 0px 3px 10px 0px #dadada;
  box-shadow: 0px 3px 10px 0px #dadada;
}

.main-img-logo {
  background: rgba(245, 222, 179, 0.5);
  margin: 4px;
  padding: 8px;
}

* {
	 box-sizing: border-box;
}
.table td, .table th {
    padding: .5rem;
    vertical-align: top;
    border-top: 1px solid #dee2e6;
}
</style>
